import React from 'react';
import { Route, Switch, useRouteMatch, useParams } from 'react-router-dom';
import RegulationListPage from './RegulationListPage/RegulationListPage';

const RegulationsFeature = () => {
  const { path } = useRouteMatch();
  const { latitude, longitude } = useParams<{
    latitude: string;
    longitude: string;
  }>();

  return (
    <Switch>
      <Route path={path} exact>
        <RegulationListPage latitude={+latitude} longitude={+longitude} />
      </Route>
    </Switch>
  );
};

export default RegulationsFeature;
